import axios from "axios";
import axiosRetry from "axios-retry";
import { isUndefined } from "../../FunctionsCore";
const getSiteContent = (siteContentSearchArguments) => {
    axiosRetry(axios, {
        "retries": 3,
        "retryCondition": (axiosError) => isUndefined(axiosError.response) || axiosError.response.status === 500,
    });
    return new window.Promise((value) => {
        axios
            .get("/apps/dnb/servlets/SiteSearchServlet", {
            "params": {
                "contentType": siteContentSearchArguments.contentType,
                "pageNumber": siteContentSearchArguments.pageNumber,
                "resourcePath": siteContentSearchArguments.resourcePath,
                "resourceType": siteContentSearchArguments.resourceType,
                "searchTerm": siteContentSearchArguments.searchTerm,
            },
        })
            .then((ax) => value(ax.data));
    });
};
export { getSiteContent };
